import axios from "axios";

let fetchPatched = false;
let axiosInterceptorId = null;

const getApiBase = () => process.env.REACT_APP_API_URL || "";

const getTrainerId = () => sessionStorage.getItem("trainerID") || "";

const shouldAttach = (url, apiBase) =>
	apiBase && typeof url === "string" && url.startsWith(apiBase);

export const setupApiAuth = (trainerID) => {
	const apiBase = getApiBase();
	if (!apiBase) return;

	if (trainerID) {
		sessionStorage.setItem("trainerID", trainerID);
	}

	if (!fetchPatched && typeof window !== "undefined" && window.fetch) {
		const originalFetch = window.fetch.bind(window);

		window.fetch = (input, init = {}) => {
			const url = typeof input === "string" ? input : input?.url;
			const trainerId = getTrainerId();

			if (shouldAttach(url, apiBase) && trainerId) {
				const headers = new Headers(init.headers || {});
				if (!headers.has("x-trainer-id")) {
					headers.set("x-trainer-id", trainerId);
				}
				return originalFetch(input, { ...init, headers });
			}

			return originalFetch(input, init);
		};

		fetchPatched = true;
	}

	if (axiosInterceptorId !== null) {
		axios.interceptors.request.eject(axiosInterceptorId);
	}

	axiosInterceptorId = axios.interceptors.request.use((config) => {
		const apiBaseNow = getApiBase();
		const trainerId = getTrainerId();
		if (!apiBaseNow || !trainerId) return config;

		const url = config.url || "";
		const fullUrl = url.startsWith("http")
			? url
			: `${apiBaseNow}${url.startsWith("/") ? "" : "/"}${url}`;

		if (fullUrl.startsWith(apiBaseNow)) {
			config.headers = {
				...(config.headers || {}),
				"x-trainer-id": config.headers?.["x-trainer-id"] || trainerId,
			};
		}

		return config;
	});
};
